/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yournextevent2Inputs */

const en_yournextevent2 = /** @type {(inputs: Yournextevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your next event`)
};

const de_yournextevent2 = /** @type {(inputs: Yournextevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein nächstes Event`)
};

/**
* | output |
* | --- |
* | "Your next event" |
*
* @param {Yournextevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yournextevent2 = /** @type {((inputs?: Yournextevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yournextevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yournextevent2(inputs)
	return de_yournextevent2(inputs)
});
export { yournextevent2 as "yourNextEvent" }